import { Link } from "react-router-dom";
import Diary from "../features/Diary/interfaces/IDiary";
import { clearDiaryState } from "../features/Diary/DiarySlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import "../styles/components/diary-entry-table.scss";
import { parseISO } from "date-fns/esm";
import formatDateAndTime from "../utils/formatDateAndTime";
import useWindowDimensions from "../utils/useWindowDimensions";
import { useEffect } from "react";

const DiaryEntryTable = (props: { diaryEntries: Diary[] }) => {
  const dispatch = useDispatch();
  const {} = useSelector((state: RootState) => state.diary);
  const { width, height } = useWindowDimensions();

  return (
    <div className="diary-entries">
      <h1 className="header">Most Recent Entries</h1>
      {width > 599 && (
        <div className="headings">
          <h2 className="headings--title">Title</h2>
          <h2 className="headings--date">Entry Date</h2>
          <h2 className="headings--time">Entry Time</h2>
        </div>
      )}
      {props.diaryEntries.map((diaryEntry) => {
        return (
          <div className="diary-entry">
            <Link
              to={{ pathname: "/diary-new-entry", state: diaryEntry }}
              onClick={() => dispatch(clearDiaryState())}
              className="diary-entry--entry_title"
            >
              {diaryEntry.entry_title}
            </Link>
            <div className="diary-entry--entry_date">
              {
                formatDateAndTime(parseISO(diaryEntry.entry_date), true)
                  .formattedDate
              }
            </div>
            <div className="diary-entry--entry_time">
              {diaryEntry.entry_time}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DiaryEntryTable;
